import { connect } from 'react-redux'
import View from './UserMenuToggle'
import { includes } from 'ramda'
import { closeSignIn, openSignIn, signOut } from '../../../../../../store/modules/session'
import compose from 'ramda/src/compose'

const mapStateToProps = state => ({
  locale: state.router.locale,
  isSignInModalOpen: state.session.isSignInModalOpen,
  isSignedIn: state.session.user !== null,
  isProfileActive: state.router.activeRoute.name === 'profile',
  isFavoritesActive: includes(state.router.activeRoute.name, [
    'favorites',
    'favoritesAr',
    'favoritesFr',
  ]),
})

const mapDispatchToProps = dispatch => ({
  openSignIn: compose(dispatch, openSignIn),
  closeSignIn: compose(dispatch, closeSignIn),
  onSignOut: compose(dispatch, signOut),
})

const UserMenuToggle = connect(mapStateToProps, mapDispatchToProps)(View)

export default UserMenuToggle
